import { useCalibrationsQuery } from "@/shared/api";
import { useSchedules } from "./useSchedules";
import { useEffect, useMemo, useRef, useState } from "react";

export function useCalibration() {
  const [isLoading, setIsLoading] = useState(true);
  const isLoaded = useRef(false);

  const { activeSchedule: calibrationActiveSchedule } = useSchedules({
    queryKey: "calibrationSchedules",
  });

  const { calibration } = useCalibrationsQuery(
    {
      calibrationId: calibrationActiveSchedule?.id ?? 0,
    },
    {
      skip: !calibrationActiveSchedule,
      selectFromResult: (result) => ({
        calibration: result.data?.result,
      }),
    }
  );

  useEffect(() => {
    if (isLoaded.current) return;

    if (calibration) {
      setIsLoading(false);
      isLoaded.current = true;
    }
  }, [calibration]);

  const calibrationResult = useMemo(() => {
    if (!calibration) return undefined;

    const sortedCalibration = [...calibration.camera_calibrations].sort(
      (a, b) => Number(a.camera_id) - Number(b.camera_id)
    );

    return {
      ...calibration,
      camera_calibrations: sortedCalibration,
    };
  }, [calibration]);

  return {
    calibration: calibrationResult,
    calibrationActiveSchedule,
    isLoading,
  };
}
